import { Component, OnInit, Input, Output,EventEmitter, AfterContentChecked } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';

@Component({
    selector: 'together-auction-dip-applicant-address',
    templateUrl: './dip.applicant.address.component.html',
    styleUrls: ['./dip.applicant.address.component.scss'],
    standalone: false
})
export class TogetherAuctionDIPApplicantAddressComponent implements OnInit {

  @Input() address_id: string;
  @Output() address_selected: EventEmitter<object> = new EventEmitter<object>();
  @Output() address_form: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();
  @Input() address_results: Array<object> = [];
  tad_applicant_address_form: UntypedFormGroup;
  tad_applicant_address_result: UntypedFormControl = new UntypedFormControl(null,[
    Validators.required
  ]);
  tad_applicant_address_result_id: UntypedFormControl = new UntypedFormControl(null,[]);

  _handleForm() {
    this.tad_applicant_address_form = this.fb.group({
      tad_applicant_address_result: this.tad_applicant_address_result,
      tad_applicant_address_result_id: this.tad_applicant_address_result_id
    });
  }

  constructor(private fb: UntypedFormBuilder) {
    this._handleForm();
  }

  ngAfterContentChecked() {
    if (this.tad_applicant_address_form.valid) {
      this.address_selected.emit({
        id: this.address_id,
        code: this.tad_applicant_address_result.value
      });
    }
  }

  ngOnInit() {

  }

}
